import { SITE_NAME } from "../lib/site.ts";

const faqs = [
  {
    q: `为什么叫${SITE_NAME}？`,
    a: `「${SITE_NAME}」是一个更有辨识度的产品名，背后想解决的是长期伏案久坐。实际提醒文字完全由你决定，也可以用于起身活动、补水、拉伸、眺望远处或活动肩颈。`,
  },
  {
    q: "项目已经开源，官方版为什么还保留授权？",
    a: "官方发行版保留授权和自动更新，是为了兼容已经发放的测试终身授权和旧版本升级链路。源码按 Apache-2.0 开放，自构建版本可以自行调整授权、公钥和更新配置。",
  },
  {
    q: "官方发行版如何继续使用？",
    a: "官方发行版仍包含 7 天试用和离线授权校验。试用结束后可选择 ¥9.9 年度授权或 ¥29.9 终身授权；已有测试终身授权用户可以继续激活使用。",
  },
  {
    q: "购买和赞助有什么区别？",
    a: "购买授权用于激活官方发行版。赞助是自愿支持项目维护，不等同于购买授权，也不会改变项目的开源许可。",
  },
  {
    q: "更换电脑后怎么办？",
    a: "官方发行版授权会与当前设备关联。重新安装同一台电脑通常不影响使用；更换电脑如果需要官方授权支持，可以通过 QQ 频道联系维护者。",
  },
  {
    q: "会议或演示时会不会被打断？",
    a: "可以通过白名单降低打扰。把会议、演示、剪辑等应用加入白名单后，命中当前应用时会自动跳过本次提醒。",
  },
  {
    q: "日常使用需要联网吗？",
    a: "不需要。激活完成后，授权校验和日常提醒都在本机完成。联网主要用于下载新版本、检查自动更新和获取支持。",
  },
];

export function Faq() {
  return (
    <div id="faq" className="mx-auto w-full max-w-3xl scroll-mt-24 px-6 py-24 sm:py-32">
      <div data-reveal="" style={{ ["--reveal-delay" as string]: "0ms" }} className="text-center">
        <h2 className="text-balance text-4xl font-semibold tracking-tight sm:text-5xl">常见问题</h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          关于开源、官方发行版、授权、白名单和跨平台的常见说明
        </p>
      </div>
      <div className="mt-12">
        {faqs.map((item, i) => (
          <div key={item.q} data-reveal="" style={{ ["--reveal-delay" as string]: `${i * 60}ms` }}>
            <details className="group border-b border-border/60">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-[17px] font-medium text-foreground/90 transition-colors hover:text-foreground [&::-webkit-details-marker]:hidden">
                {item.q}
                <svg
                  viewBox="0 0 24 24"
                  className="size-5 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-45"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M12 5v14M5 12h14" />
                </svg>
              </summary>
              <p className="-mt-1 pb-5 pr-8 text-[15px] leading-relaxed text-muted-foreground">
                {item.a}
              </p>
            </details>
          </div>
        ))}
      </div>
    </div>
  );
}
